import ResponseBodyToggle_vue_vue_type_script_setup_true_lang_default from "./ResponseBodyToggle.vue.script.js";
//#region src/v2/blocks/response-block/components/ResponseBodyToggle.vue
var ResponseBodyToggle_default = ResponseBodyToggle_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ResponseBodyToggle_default as default };

//# sourceMappingURL=ResponseBodyToggle.vue.js.map